import styled from 'styled-components';

import { devices } from '@/UI/Styles/Queries';

export const Container = styled.div`
  display: flex;
  margin-bottom: 17px;
  align-items: center;
  color: ${({ theme }) => theme.palette.grays80};
  @media ${devices['no-mobile']} {
    margin-bottom: 25px;
  }
  i {
    width: 20px;
  }
  path {
    fill: ${({ theme }) => theme.palette.grays80};
  }
`;
